import { makeAutoObservable } from "mobx";

export interface Vendor {
  id: string;
  name: string;
  netSuiteName?: string;
  attachmentFolder?: string;
  isActive: boolean;
}

export interface NewVendor extends Omit<Vendor, 'id'> { }

export class VendorModel implements NewVendor {
  readonly id?: string;
  name: string;
  netSuiteName?: string;
  attachmentFolder?: string;
  isActive: boolean = true;

  constructor(vendor: Vendor | NewVendor) {
    makeAutoObservable(this);

    this.id = 'id' in vendor ? vendor.id : undefined;
    this.name = vendor.name;
    this.netSuiteName = vendor.netSuiteName;
    this.attachmentFolder = vendor.attachmentFolder;
    this.isActive = vendor.isActive ?? true;
  }
  get canSave() {
    return Boolean(this.name.trim());
  }
  setName(name: string) {
    this.name = name;
  }
  setNetSuiteName(netSuiteName?: string) {
    this.netSuiteName = netSuiteName;
  }
  setAttachmentFolder(attachmentFolder?: string) {
    this.attachmentFolder = attachmentFolder;
  }
}